// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","Panel":"bci_a bgu_cw bgu_jx bgu_jo bgu_rh bgu_vf"};